export class TrustApiError extends Error {}

export class TrustFrameError extends Error {}
